import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';

// Material UI
import {
	Button,
	Box,
	Typography,
	Tooltip,
	withStyles,
	Paper,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
} from '@material-ui/core';

import AuthUserContainer from '../../containers/AuthUser';
import EmailReadyDriverShiftContainer from '../../containers/EmailReadyDriverShift';
import EnhancedTable from '../../components/table/EnhancedTable';
import FilterHeader from '../../components/table/FilterHeader';
import { getGlobalClasses } from '../../themes';
import ImageZoomDialog from '../../components/dialogs/ImageZoomDialog';
import documentIcon from '../../images/document.svg';
import CheckIcon from '@material-ui/icons/Check';
import CancelIcon from '@material-ui/icons/Clear';
import DenyIcon from '@material-ui/icons/Block';

const EMAIL_READY_DRIVE_SHIFT_STATUSES = {
	QUEUED: 'QUEUED',
	PROCESSING: 'PROCESSING',
	PROCESSED: 'PROCESSED',
};

const EMAIL_READY_DRIVE_SHIFT_ORDER_STATUSES = {
	SKIPPED: 'SKIPPED',
	ERROR: 'ERROR',
	SENT: 'SENT',
};

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		documentIcon: {
			cursor: 'pointer',
			marginRight: 12,
			display: 'inline-block',
			width: 21,
			height: 25,
			backgroundImage: `url('${documentIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
			flexShrink: 0,
			// cursor : 'pointer',
		},
	};
};

class CustomerPaperworkEmailLogs extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isZoomOpen: false,
			order: 'asc',
			orderBy: 'userId',
		};
	}

	componentDidMount() {
		const { emailReadyDriverShifts, searchEmailReadyDriverShifts } = this.props;
		console.log('emailReadyDriverShifts', emailReadyDriverShifts);
		if (_.isEmpty(emailReadyDriverShifts)) {
			searchEmailReadyDriverShifts();
		} else {
			this.formatShifts();
		}
	}

	componentDidUpdate(prevProps) {
		const { emailReadyDriverShifts } = this.props;
		if (prevProps.emailReadyDriverShifts !== emailReadyDriverShifts) {
			this.formatShifts();
		}
	}

	showZoomImageDialog = (imageUrls, tmwOrderId) => {
		this.setState({ isZoomOpen: true, imageUrls, tmwOrderIdForImageZoom: tmwOrderId });
	};
	hideZoomImageDialog = () => {
		this.setState({
			imageUrls: undefined,
			tmwOrderIdForImageZoom: undefined,
			isZoomOpen: false,
		});
	};

	formatShifts = () => {
		const { classes } = this.props;
		const { emailReadyDriverShifts, userMap, resourceMap } = this.props;

		const emailReadyDriverShiftRows = emailReadyDriverShifts.map((shift) => {
			const {
				emailReadyDriverShiftId,
				timeClockShiftId,
				tmwShiftId,
				dateShiftStarted,
				userId,
				geoTabName,
				errorReason,
				status,
				dateCreated,
				emailReadyDriverShiftOrders,
			} = shift;

			const user = userMap[userId] || { firstName: 'missing' };
			const userDisplay = `${user.firstName} ${user.lastName}`;
			const dateShiftStartedFormatted = moment(dateShiftStarted).format('M/D/YY h:mm a');
			const shiftDisplay = (
				<div>
					<div
						style={{
							fontSize: '16px',
							fontWeight: '600',
							lineHeight: '1.2',
							paddingBottom: '10px',
						}}
					>
						<div>TMW Shift #</div>
						<div>{tmwShiftId}</div>
					</div>
					<div style={{ lineHeight: '1.2', paddingBottom: '10px' }}>
						<div>{userDisplay}</div>
						<div style={{ fontSize: '13px', color: '#666' }}>{geoTabName}</div>
					</div>
					<div style={{ lineHeight: '1.2' }}>
						<div>Shift Start</div>
						<div>{dateShiftStartedFormatted}</div>
					</div>
				</div>
			);

			const orderDisplay = (
				<Table size={'small'} aria-label="order table">
					<TableHead>
						<TableRow>
							<TableCell>TMW #</TableCell>
							<TableCell>Bill To</TableCell>
							<TableCell>Status</TableCell>
							<TableCell>Emailed</TableCell>
							<TableCell>Attachments</TableCell>
							<TableCell>Date</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{emailReadyDriverShiftOrders.map((order) => {
							const {
								emailReadyDriverShiftOrderId,
								tmwOrderId,
								billTo,
								stopNumbers,
								attachmentResourceIds,
								sentToCustomerEmails,
								skipReason,
								errorReason,
								status,
								dateCreated,
							} = order;

							const attachments = attachmentResourceIds.map((resourceId) => {
								const resource = resourceMap[resourceId];
								console.log(`Missing ResourceId: ${resourceId}`);
								if (!resource) {
									return { isMissing: true };
								}
								return resource;
							});

							const documentDisplay = _.isEmpty(attachmentResourceIds) ? (
								'-'
							) : (
								<div
									style={{
										position: 'relative',
										marginBottom: '20px',
									}}
									onClick={() => {
										this.showZoomImageDialog(
											attachments.map((d) => d.url),
											tmwOrderId
										);
									}}
								>
									{attachments.map((attachment, i) => {
										return (
											<div
												key={attachment.url}
												className={classes.documentIcon}
												style={{ position: 'absolute', left: i * 7 }}
											/>
										);
									})}
								</div>
							);

							return (
								<TableRow key={emailReadyDriverShiftOrderId}>
									<TableCell>{tmwOrderId}</TableCell>
									<TableCell>{billTo || 'n/a'}</TableCell>
									<TableCell>
										<div>{this.renderOrderStatus(status)}</div>
										<div>{errorReason}</div>
										<div>{skipReason}</div>
									</TableCell>
									<TableCell>{this.renderCustomerEmailCell({ sentToCustomerEmails })}</TableCell>
									<TableCell>{documentDisplay}</TableCell>
									<TableCell>{moment(dateCreated).format('M/D/YY h:mm a')}</TableCell>
								</TableRow>
							);
						})}
					</TableBody>
				</Table>
			);

			const row = {
				key: emailReadyDriverShiftId,
				shiftDisplay,
				orderDisplay,
				tmwShiftId,
				timeClockShiftId,
				userDisplay: `${user.firstName} ${user.lastName}`,
				geoTabName,
				dateShiftStarted,
				dateShiftStartedFormatted: moment(dateShiftStarted).format('M/D/YY h:mm a'),
				dateCreated,
				shiftStyle: {
					width: '250px',
				},
				orderStyle: {
					width: '87%',
				},
				dateCreatedFormatted: moment(dateCreated).format('M/D/YY h:mm a'),
				status,
				errorReason,
			};
			return row;
		});
		this.setState({ emailReadyDriverShiftRows });
	};

	render() {
		const { classes } = this.props;
		const { emailReadyDriverShiftRows } = this.state;

		if (!emailReadyDriverShiftRows) {
			return (
				<div>
					<span style={{ fontSize: 24, padding: 20, fontWeight: 300, color: '#666' }}>
						Fetching Driver Shifts...
					</span>
				</div>
			);
		}

		const columns = [
			{ label: 'Shift', sortId: 'shiftDisplay', displayId: 'shiftDisplay', useStyle: 'shiftStyle' },
			{
				label: 'Orders',
				displayId: 'orderDisplay',
				useStyle: 'orderStyle',
			},
			//{ label: 'Actions', sortId: 'fix', isNotSortable: true, displayId: 'actionButtons' },
		];

		return (
			<Fragment>
				<FilterHeader label={'Delivery Logs for Customer Paperwork '} canMakeUpdates={true} />

				<Paper className={classes.globalMainPaper}>
					<EnhancedTable
						rows={emailReadyDriverShiftRows}
						columns={columns}
						isDense={true}
						defaultOrder={'desc'}
						defaultOrderBy={'dateCreated'}
					/>
				</Paper>

				<ImageZoomDialog
					open={this.state.isZoomOpen}
					onClose={this.hideZoomImageDialog}
					imageUrls={this.state.imageUrls}
					tmwOrderId={this.state.tmwOrderIdForImageZoom}
				/>
			</Fragment>
		);
	}

	renderOrderStatus = (status) => {
		if (status === EMAIL_READY_DRIVE_SHIFT_ORDER_STATUSES.SENT) {
			return (
				<div style={{ display: 'flex', alignItems: 'center', color: 'green' }}>
					<CheckIcon style={{ marginRight: 1, height: 20 }} />
					<strong>{_.startCase(status)}</strong>
				</div>
			);
		} else if (status === EMAIL_READY_DRIVE_SHIFT_ORDER_STATUSES.SKIPPED) {
			return (
				<div style={{ display: 'flex', alignItems: 'center', color: '#999' }}>
					<DenyIcon style={{ marginRight: 3, height: 20 }} />
					<strong>{_.startCase(status)}</strong>
				</div>
			);
		} else if (status === EMAIL_READY_DRIVE_SHIFT_ORDER_STATUSES.SKIPPED) {
			return (
				<div style={{ display: 'flex', alignItems: 'center', color: '#C99930' }}>
					<CancelIcon style={{ marginRight: 3, height: 20 }} />
					<strong>{_.startCase(status)}</strong>
				</div>
			);
		} else {
			return <strong>{_.startCase(status || 'missing')}</strong>;
		}
	};

	renderCustomerEmailCell = ({ sentToCustomerEmails }) => {
		if (!sentToCustomerEmails || sentToCustomerEmails.length === 0) {
			return <div>No emails available</div>;
		}

		const visibleEmails = sentToCustomerEmails.slice(0, 2);
		const hiddenEmails = sentToCustomerEmails.slice(2);

		return (
			<Box>
				{visibleEmails.map((email, index) => (
					<div key={index} style={{ fontSize: '12px', lineHeight: '1.2' }}>
						{email}
					</div>
				))}
				{hiddenEmails.length > 0 && (
					<Tooltip title={hiddenEmails.join(', ')}>
						<div
							style={{
								border: '1px solid #eee',
								backgroundColor: '#f7f7f7',
								cursor: 'pointer',
								fontSize: '12px',
								padding: '2px 4px',
								borderRadius: '4px',
							}}
						>
							{hiddenEmails.length} More...
						</div>
					</Tooltip>
				)}
			</Box>
		);
	};
}

CustomerPaperworkEmailLogs.propTypes = {
	authUser: PropTypes.object,
	showErrors: PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,
	searchEmailReadyDriverShifts: PropTypes.func.isRequired,
	emailReadyDriverShifts: PropTypes.array,
	userMap: PropTypes.object,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	EmailReadyDriverShiftContainer,
])(CustomerPaperworkEmailLogs);
